import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=7abcb271&scoped=true"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"
import style0 from "./Doc.vue?vue&type=style&index=0&id=7abcb271&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abcb271",
  null
  
)

export default component.exports